import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All PERMISSION SERVICE
export const getPermissionsService = createAsyncThunk(
  "general/getPermissionsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.permissionsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  All NOTIFICATIONS SERVICE
export const getNotificationsService = createAsyncThunk(
  "general/getNotificationsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.notificationsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
//
// GET =>  All STATISTICS SERVICE
export const getStatisticsService = createAsyncThunk(
  "general/getStatisticsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.statisticsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE USER SERVICE
export const createContactUservice = createAsyncThunk(
  "general/createUserService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.contactUsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET ALL CONTACT USER SERVICE
export const getAllContactUSerService = createAsyncThunk(
  "general/getAllContactUSerService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.contactUsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

//
//
//
// GET =>  GET ALL GOVER  SERVICE
export const getAllgovernoratesService = createAsyncThunk(
  "general/getAllgovernoratesService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.governoratesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE Governorates SERVICE
export const createGovernoratesService = createAsyncThunk(
  "general/createGovernoratesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.governoratesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE Governorates SERVICE
export const deleteGovernoratesService = createAsyncThunk(
  "general/deleteGovernoratesService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.governoratesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE Governorates SERVICE
export const updateGovernoratesService = createAsyncThunk(
  "general/updateGovernoratesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.governoratesURL}/${params?.id}`,
        params?.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET AREA BY GOV
export const getAreaByGovService = createAsyncThunk(
  "general/getAreaByGovService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.areasURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE AREA SERVICE
export const createAreaService = createAsyncThunk(
  "general/createGovernoratesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.areasURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE AREA SERVICE
export const deleteAreaService = createAsyncThunk(
  "general/deleteAreaService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.areasURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE AREA SERVICE
export const updateAreaService = createAsyncThunk(
  "general/updateGovernoratesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.areasURL}/${params?.id}`,
        params?.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
